'use client';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

const useLocale = () => {
  const [cookies, setCookie] = useCookies(['locale_selection']);
  const localeSelection = cookies.locale_selection || { currency: 'GBP', countryCode: 'GB' };

  useEffect(() => {
    if (!cookies.locale_selection) {
      setCookie('locale_selection', JSON.stringify({ countryCode: 'GB', currency: 'GBP' }));
    }
  }, [cookies, setCookie]);

  const getCountry = () => localeSelection.countryCode;
  const getCurrency = () => localeSelection.currency;
  const locale = 'en_GB';
  const ctLocale = 'en';

  return { getCountry, getCurrency, locale, ctLocale };
};

export default useLocale;
